import { ICampaignArticle } from 'containers/Learn/CampaignPage/CampaignPage.types';

export const getUrl = (type: ICampaignArticle['typeName'], urlName: string) =>
  `/learn/${type.toLowerCase()}/${urlName}`;
